<template>
  <div class="app_content_con">
    <div class="navs">
      <div class="navs_top">
        <div class="navs_top_name">
          <span>{{ tabList.name }}</span
          ><span><i></i><i></i></span>
        </div>
        <div class="line" v-if="tabListAll.length"></div>
        <div class="navs_top_name" v-if="tabListAll.length">
          <div class="top_tab">
            <el-tabs
              v-model="cloumnIdd"
              @tab-click="handleClick"
              class="no-underline-tabs"
            >
              <el-tab-pane
                :label="t.name"
                :name="t.id"
                v-for="(t, index) in tabListAll"
                :key="index"
              ></el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div
      class="main_content wow slideInLeft"
      data-wow-duration="0.3s"
      data-wow-offset="10"
      :style="ys"
    >
      <slot name="main_content"></slot>
    </div>
  </div>
</template>

<script>
import { navList } from '../const';
import { isHttpLink } from '@/utils';
export default {
  name: 'contentList',
  props: {
    tabList: {
      type: Object,
      default: function () {
        return {};
      },
    },
    currentIndex: { type: Number, default: 0 },
    leftTab: {
      type: Number,
      default: 0,
    },
    cloumnId: {
      type: String,
      default: '',
    },
    ys: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  data() {
    return {
      cloumnIdd: this.cloumnId,
      cloumnName: '',

      tabListAll: [],
      list: navList,
    };
  },
  mounted() {
    if (this.$route.query && this.$route.query.cloumnId) {
      this.cloumnIdd = this.$route.query.cloumnId;
    }
    this.tabList.tab.map((t, index) => {
      if (t.id == this.cloumnIdd) {
        this.cloumnName = t.name;
      }
    });
    // 把tabUp和tab放到一起进行渲染
    if (this.tabList) {
      this.tabListAll = [];
      this.tabList.tab.map((t) => {
        this.tabListAll.push(t);
      });
      if (this.tabList.tabUp) {
        this.tabList.tabUp.map((t) => {
          this.tabListAll.push(t);
        });
      }
    }
  },

  methods: {
    handleClick(tab, event) {
      this.tabListAll.map((t) => {
        if (t.id == tab.name) {
          this.navClick(t, tab.index);
        }
      });
    },
    navClick(v, i) {
      this.cloumnIdd = v.id;
      this.cloumnName = v.name;
      if (isHttpLink(v.accessPath)) {
        window.location.href = v.accessPath;
      } else {
        this.$router.push({
          path: v.accessPath,
          query: { cloumnId: this.cloumnIdd },
        });
      }
      // this.$router.push({
      //   path: v.accessPath,
      //   query: { cloumnId: this.cloumnIdd },
      // });
      // this.$emit('tabChagnge', v, this.cloumnIdd);
    },
    toList(v) {
      v.subnav.map((s) => {
        if (v.accessPath == s.accessPath) {
          this.cloumnIdd = s.id;
          this.cloumnName = s.name;
          this.$router.push({
            path: v.accessPath,
            query: { cloumnId: this.cloumnIdd },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.navs {
  .navs_top {
    padding: 1.1667rem 6.25% 0;
    width: 100%;
    // height: 7.5rem;
    padding-bottom: 1.6667rem;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.05);

    .navs_top_name {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #424451;
      height: 2.5rem;
      line-height: 2.5rem;
      position: relative;
      span {
        font-size: 1.5rem;
        font-family: SourceHanSansCN-Medium;
        i {
          display: inline-block;
          width: 0.25rem;
          height: 0.25rem;
          background: #c2c4ce;
          margin-left: 0.4167rem;
        }
      }
      .top_tab {
        margin-top: 0.6667rem;
        width: 100%;
        overflow: hidden;

        .tabList_item {
          height: 1.8333rem;
          line-height: 1.8333rem;
          padding: 0 1rem;
          background: #f0f1f2;
          border-radius: 50px;
          font-size: 0.8333rem;
          margin-right: 0.9167rem;
          cursor: pointer;
          &.active {
            background: #6b6d7a;
            color: #fff;
          }
        }

        // .prev {
        //   position: absolute;
        //   bottom: 0;
        //   left: 0;
        //   display: inline-block;
        //   width: 10px;
        //   height: 10px;

        //   border-color: #2a2a2a;
        //   border-style: solid;
        //   border-width: 1px 1px 0 0;
        //   transform: rotate(-135deg);
        //   z-index: 99;
        // }
        .next {
          position: absolute;
          bottom: 0.4167rem;
          right: 0.1667rem;
          width: 10px;
          height: 10px;
          border-color: #2a2a2a;
          border-style: solid;
          border-width: 1px 1px 0 0;
          transform: rotate(45deg);
          z-index: 99;
        }
      }
    }
    .line {
      width: 100%;
      background: #dadbdf;
      height: 1px;
    }
  }
}
.main_content {
  width: 87.2%;
  margin: 0 auto;
}
::v-deep {
  .no-underline-tabs {
    .el-tabs__nav-wrap::after {
      display: none;
    }
    .el-tabs__active-bar {
      display: none;
    }
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__item {
      height: 1.8333rem;
      line-height: 1.8333rem;
      background: #f0f1f2;
      color: #6b6d7a;
      margin: 0 0.4167rem;
      border-radius: 4.1667rem;
      text-align: center;
      padding: 0 1rem;
      font-size: 0.8333rem;
    }
    .el-tabs__item.is-active {
      background: #6b6d7a;
      color: #fff;
      border-radius: 4.1667rem;
    }
    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      line-height: 2.5rem;
    }
    .el-tabs__nav-next {
      box-shadow: -6px 0px 7px 0px rgba(0, 0, 0, 0.1);
    }
    .el-tabs__nav-prev {
      box-shadow: 6px 0px 7px 0px rgba(0, 0, 0, 0.1);
    }
    .el-tabs__item.is-top:last-child {
      padding-right: 1rem !important;
    }
    .el-tabs__item.is-top:nth-child(2) {
      padding-left: 1rem !important;
    }
  }
}
</style>
